
    var WINDOWS_VERSION_MAP = {
        '6.4': '10.0',
        '6.3': '8.1',
        '6.2': '8',
        '6.1': '7',
        '6.0': 'Vista',
        '5.2': 'Server 2003',
        '5.1': 'XP',
        '5.01': '2000 SP1',
        '5.0': '2000',
        '4.0': '4.0',
    };

    var NODE_OS_TYPES = {
        Darwin: 'OSX',
        Windows_NT: 'Windows',
    };

    var context = typeof window !== 'undefined' ? window : global;

    var DEFAULT = {
    };

    var NODE_PROCESS = {
        product: 'solclientjs',
        platform: 'node',
        agent: 'node',
        process: context.process,
    };

    // Worst case fallbacks
    var BROWSER_PROCESS = {
        product: 'solclientjs',
        platform: 'unknown',
        agent: 'Gecko',
    };

    function getBrowserAgentInfo() {
        /* eslint-env browser */
        var navObj = typeof navigator !== 'undefined' ? navigator : null;
        if (!navObj) { return null; }
        var agentStr = navigator.userAgent;

        // Execute these regex checks against the user agent string in this order.
        // The earlier browsers have a lot of impersonation substrings in their user
        // agent list so we positively test for them before considering the browsers
        // that are frequently impersonated.
        var browsers = [
            ['edge', /Edge\/([0-9._]+)/],
            ['chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9.]+)(:?\s|$)/],
            ['firefox', /Firefox\/([0-9.]+)(?:\s|$)/],
            ['opera', /Opera\/([0-9.]+)(?:\s|$)/],
            ['opera', /OPR\/([0-9.]+)(:?\s|$)$/],
            ['ie', /Trident\/7\.0.*rv:([0-9.]+).*\).*Gecko$/],
            ['ie', /MSIE\s([0-9.]+);.*Trident\/[4-8].0/], // Edit: IE11 in IE9 emu mode uses Trident 8
            ['ie', /MSIE\s(7\.0)/],
            ['bb10', /BB10;\sTouch.*Version\/([0-9.]+)/],
            ['android', /Android\s([0-9.]+)/],
            ['ios', /Version\/([0-9._]+).*Mobile.*Safari.*/],
            ['safari', /Version\/([0-9._]+).*Safari/]];

        var agentInfo = {
            browser: { name: 'unknown', version: '0.0.0' },
            platform: { os: 'unknown', arch: 'unknown', version: 'unknown' },
        };

        var agentHas = function () {
            var strs = [], len = arguments.length;
            while (len--) strs[len] = arguments[len];

            return strs.some(function (str) { return agentStr.indexOf(str) >= 0; });
        };
        var firstValue = function () {
            var vals = [], len = arguments.length;
            while (len--) vals[len] = arguments[len];

            return vals.filter(Boolean).shift();
        };

        Object.assign(
            agentInfo, // start with fallbacks above
            // 1. Run the callback below for each browser name/regex-rule pair.
            // 2. Decompose the pair into variables called `key` and `rule`.
            browsers.map(function (ref) {
                var key = ref[0];
                var rule = ref[1];

                // 3. Skip if the rule doesn't match the user agent string.
                if (!rule.test(agentStr)) { return false; }
                // 4. Get the matches for the rule.
                var match = rule.exec(agentStr);
                // 5. Extract the version from match group 1.
                var versionStrs = match && match[1].split(/[._]/).slice(0, 3);
                // 6. Convert the version strings to numbers.
                var version = versionStrs.map(function (str) { return parseInt(str, 10); });
                // 7. Ensure our version tuple is length 3 by appending 0 elements.
                while (version.length < 3) { version.push(0); }
                // 8. Return an agentInfo object in the same form as above, consuming the version array.
                return { browser: { name: key, version: version.join('.') } };
            }).filter(Boolean).shift()); // 9. Filter out anything that returned `false` (#3)...
        // 10. ...and return the first element.

        // Now try to extract platform info
        var os = firstValue(
            agentHas('Windows Phone') && 'WindowsPhone',
            agentHas('Windows') && 'Windows',
            agentHas('Linux') && 'Linux',
            agentHas('like Mac OS X') && 'iOS',
            agentHas('OS X') && 'OSX',
            agentHas('Android', 'Adr') && 'Android',
            agentHas('BB10', 'RIM Tablet OS', 'BlackBerry') && 'BlackBerry'
        );
        var versionTests = {
            'Windows': function () {
                return firstValue(
                    agentHas('Win16') && '3.1.1',
                    agentHas('Windows CE') && 'CE',
                    agentHas('Windows 95') && '4.00.950',
                    agentHas('Windows 98; Win 9x 4.90') && '4.90',
                    agentHas('Windows 98') && '4.10',
                    (function () {
                        // Look in the first set of parentheses for a version string key.
                        // This will fail when Windows 16 comes out
                        var parenParts = agentStr.match(/\(.+?\)/);
                        var versionPart = parenParts[0];
                        if (!versionPart) { return false; }
                        var versionMatch = function (str) { return versionPart.indexOf(str) >= 0; };
                        return firstValue.apply(void 0, Object.keys(WINDOWS_VERSION_MAP).map(function (k) { return versionMatch(k) && WINDOWS_VERSION_MAP[k]; }));
                    })()
                );
            },
            'OSX': function () { return agentStr.match(/OS X ((\d+[._])+\d+)\b/)[1]; },
            'Linux': function () { return ''; },
            'iOS': function () { return agentStr.match(/OS ((\d+[._])+\d+) like Mac OS X/)[1]; },
            'Android': function () { return agentStr.match(/(?:Android|Adr) ((\d+[._])+\d_)/)[1]; },
            'BlackBerry': function () { return agentStr.match(/(?:Version\/|RIM Tablet OS )((\d+\.)+\d+)/)[1]; },
        };
        var versionTest = versionTests[os];
        agentInfo.platform.os = os || 'Unknown';
        agentInfo.platform.version = (versionTest && versionTest() || '0.0.0').replace(/_/g, '.');
        return agentInfo;
    }
    /* eslint-env shared-browser-node */

    try {
        if (context.navigator) {
            // These are historical defaults
            var safeEncode = function (str) { return str.replace(/[^a-zA-Z0-9_/.]/g, '-'); };
            Object.assign(BROWSER_PROCESS, {
                platform: context.navigator.platform,
                agent: context.navigator.product,
                description: safeEncode(context.navigator.userAgent),
                navigator: context.navigator,
            });
            var browserAgentInfo = getBrowserAgentInfo();
            if (browserAgentInfo) {
                BROWSER_PROCESS.agent = safeEncode(((browserAgentInfo.browser.name) + "-" + (browserAgentInfo.browser.version)));
                BROWSER_PROCESS.platform = (BROWSER_PROCESS.agent) + "-" + (safeEncode(
                    ((browserAgentInfo.platform.os) + "-" + (browserAgentInfo.platform.version))));
            }
        }
        if (context.process) {
            var os = __webpack_require__(527); // eslint-disable-line global-require
            var ostype = os.type();
            var osname = NODE_OS_TYPES[ostype] || ostype || 'unknown';
            var nodeVersionStr = "node-" + (process.version.substr(1));
            Object.assign(NODE_PROCESS, {
                platform: (nodeVersionStr + "-" + osname + "-" + (os.release()) + "-" + (os.arch())),
                agent: nodeVersionStr,
                description: nodeVersionStr,
            });
        }
    } catch (ex) {
        // Fall back to defaults
    }

    var Process = Object.assign({}, DEFAULT,
        true ? BROWSER_PROCESS : {},
        false ? NODE_PROCESS : {});

    export default Process;


//export default Process;